export default __webpack_public_path__ + "static/main-2585f5adf5a17ab20214d5dd1bba8e52.jpeg";